import { SVG, SVGProps } from './svg'

export function IconChartBar(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <path d="M19 4l1 1v14l-1 1h-2l-1-1V5l1-1h2zm-5 15V9l-1-1h-2l-1 1v10l1 1h2l1-1zm-7 1H5l-1-1v-6l1-1h2l1 1v6l-1 1z" />
    </SVG>
  )
}
